export const CATEGORIES = ['Society & Action', 'Future Care', 'Heritage in Motion', 'Ecology & Action'];
export const PROGRAMMES = [
	'Art & Design Management',
	'Design Theory',
	'Designer Maker',
	'Design',
	'Fashion & Textile Design',
	'Interaction',
	'Graphic Design',
	'Media Design',
	'Photography',
	'Animation',
	'Architecture',
	'Design & Visual Art Teacher'
];
